import React, { useMemo } from 'react';
import { LineChart, Keys, DotConfig } from '@tcc/fds-charts';
import { getMessage } from 'util/locale';
import { inferUnit } from 'util/unitConversion';
import COLORS from 'constants/colors';
import { formatNumberK } from 'util/formatters/numberFormatter';

type ChartProps = {
  multipleHybrids?: boolean;
};

export const Chart = ({ multipleHybrids }: ChartProps) => {
  const chartConfiguration = useMemo(() => {
    const config: {
      multipleHybrids: {
        keys: Keys;
        dots: { fixed: DotConfig; dynamic: DotConfig };
      };
      singleHybrid: {
        keys: Keys;
        dots: { fixed: DotConfig; dynamic: DotConfig };
      };
    } = {
      multipleHybrids: {
        keys: {
          toPlot: [
            [
              {
                key: 'yield',
              },
            ],
            [
              {
                key: 'yield',
                color: COLORS.scenarios['zone-6'],
              },
            ],
          ],
          perDataset: true,
          main: 'yield',
        },
        dots: {
          fixed: {
            perDataset: true,
            colors: [
              COLORS.scenarios.bulkScriptRecommendation,
              COLORS.scenarios['zone-6'],
            ],
            labels: [getMessage('fvss-rec'), getMessage('fvss-rec')],
          },
          dynamic: {
            color: COLORS.scenarios.newPlan,
            label: getMessage('your-entry'),
          },
        },
      },
      singleHybrid: {
        keys: {
          toPlot: [
            {
              key: 'yield',
            },
          ],
          main: 'yield',
        },
        dots: {
          fixed: {
            color: COLORS.scenarios.bulkScriptRecommendation,
            label: getMessage('fvss-rec'),
          },
          dynamic: {
            color: COLORS.scenarios.newPlan,
            label: getMessage('your-entry'),
          },
        },
      },
    };

    const selectedConfig = multipleHybrids
      ? config.multipleHybrids
      : config.singleHybrid;
    return {
      keys: selectedConfig.keys,
      axis: {
        x: {
          label: getMessage('planting-rate', {
            seedDensityUnit: inferUnit('seed-density').symbol.quantitySpecific,
          }),
          step: 5,
          tickFormatter: formatNumberK,
        },
        y: {
          label: `${getMessage('estimated-yield')} (${inferUnit('area-density.yield').symbol.quantitySpecific})`,
        },
      },
      dots: selectedConfig.dots,
      tooltip: true,
    };
  }, [multipleHybrids]);

  return (
    <div className="chart">
      <LineChart {...chartConfiguration} />
    </div>
  );
};
